var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../assets/images/profile.svg"),"alt":""}}),_c('div',{staticClass:"text"},[_c('h5',{staticClass:"blue-text"},[_vm._v(_vm._s(_vm.user.getNombreCompleto()))]),_c('span',{staticClass:"blue-text"},[_vm._v(_vm._s(_vm.formatUserCedula(_vm.user.cedula)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }